import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
export function YNSButton(t0) {
  const $ = _c(7);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props.className) {
    t1 = cn("yns-global-button", props.className, "");
    $[2] = props.className;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props || $[5] !== t1) {
    t2 = <Button {...props} className={t1} />;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}